// extracted by mini-css-extract-plugin
module.exports = {"layout":"layout_layout__3o1Da","main":"layout_main__u5eQU"};